import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import SectionHeading from './SectionHeading'

export const NumberedListSection = ({ section, className = 'py-6 leading-loose' }) => {
  const { heading, list } = section
  const Heading = heading ? 'h3' : 'h2'

  return (
    <section className={className}>
      <SectionHeading>{heading}</SectionHeading>

      {list.map(item => (
        <div
          key={item.heading}
          className="w-11/12 mx-auto border-b last:border-none border-b-black grid grid-cols-[auto_1fr] gap-x-4 items-center py-5 leading-tight "
        >
          <Heading className="text-2xl font-black text-center w-10 ">{item.heading}</Heading>
          <div className="text-sm " dangerouslySetInnerHTML={{ __html: item.content }} />
        </div>
      ))}
    </section>
  )
}

NumberedListSection.propTypes = {
  section: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        content: PropTypes.string,
      })
    ),
    strapi_component: PropTypes.string,
    heading: PropTypes.string,
  }),
  className: PropTypes.string,
}

export const query = graphql`
  fragment NumberedListSection on STRAPI__COMPONENT_SECTION_NUMBERED_LIST {
    id
    list {
      heading
      content
    }
    strapi_component
    heading
  }
`

export default NumberedListSection
